// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l6uv1","index":"styles_index__jqqDy"};